import React from 'react'
import { Link } from "gatsby"

import Related from '../components/styles/RelatedBikesStyle'

export default function RelatedBikes(props) {

  const { bike1, bike2, bike3, bike1img, bike2img, bike3img, bikeLink1, bikeLink2, bikeLink3 } = props;

  return (
    <Related>
      <div className="related-title">
       <h2>Related Air Bikes</h2>
      </div>
      <div className="related-bike-container">
      <p>{bike1}</p>
      <div className="img-container">
        <img
          className="bike-img"
          src={bike1img}
          alt={bike1}
        />
      </div>
        <Link to={bikeLink1}><button className="btn-review">Read Review</button></Link>
      </div>
      <div className="related-bike-container">
        <p>{bike2}</p>
        <div className="img-container">
          <img
            className="bike-img"
            src={bike2img}
            alt={bike2}
          />
        </div>
        <Link to={bikeLink2}><button className="btn-review">Read Review</button></Link>
      </div>
      <div className="related-bike-container">
      <p>{bike3}</p>
        <div className="img-container">
          <img
            className="bike-img bike3"
            src={bike3img}
            alt={bike3}
          />
        </div>
        <Link to={bikeLink3}><button className="btn-review">Read Review</button></Link>
      </div>

    </Related>
  )
}
